import { useCallback } from "react";
import { Space, Tag } from "antd";
import { COLORS } from "../../../consts/index.js";
import { STATUS } from "./harvestEntryConstants.js";
import { safeColor } from "./harvestEntryHelpers.js";

export function useHarvestEntryStatusPill({
  rowHasPendingChanges,
  getEffectiveStatus,
}) {
  const solidTagStyle = (color) => ({
    backgroundColor: color,
    borderColor: color,
    color: "#ffffff",
    fontWeight: 700,
  });

  const statusPill = useCallback(
    (row) => {
      const hasPending = rowHasPendingChanges(row);

      if (row.pendingUnharvest) {
        return (
          <Space size={6} align="center" style={{ justifyContent: "center" }}>
            <Tag color="processing">Will be unharvested</Tag>
            {hasPending && (
              <span
                style={{
                  display: "inline-block",
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: COLORS.primaryBlue,
                }}
              />
            )}
          </Space>
        );
      }

      const eff = getEffectiveStatus(row);

      let tag = null;
      if (eff === STATUS.DISCARDED) {
        tag = (
          <Tag
            style={solidTagStyle(safeColor("#fa634f", COLORS?.dangerRed))}
            className="m-0"
          >
            Discarded
          </Tag>
        );
      } else if (eff === STATUS.HARVESTED) {
        tag = (
          <Tag
            style={solidTagStyle(safeColor("#32CD32", COLORS?.successGreen))}
            className="m-0"
          >
            Harvested
          </Tag>
        );
      } else {
        tag = (
          <Tag color="default" className="m-0">
            Planted
          </Tag>
        );
      }

      return (
        <Space size={6} align="center" style={{ justifyContent: "center" }}>
          {tag}
          {hasPending && (
            <span
              style={{
                display: "inline-block",
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: COLORS.primaryBlue,
              }}
            />
          )}
        </Space>
      );
    },
    [getEffectiveStatus, rowHasPendingChanges],
  );

  return { statusPill };
}
